// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalBody_container__3y-Ph"};